<template>
    <div class="sso-loading">
        <div class="sso-card">
            <template v-if="error">
                <div class="sso-icon sso-icon--err">!</div>
                <p class="sso-error">{{ error }}</p>
                <p class="sso-hint">Preusmjeravanje na prijavu…</p>
            </template>
            <template v-else>
                <div class="sso-spinner"></div>
                <p class="sso-text">Prijava u tijeku…</p>
            </template>
        </div>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: "SsoLogin",

    data() {
        return {
            error: null
        };
    },

    mounted() {
        let vm = this;
        const token = this.$route.query.t;

        if (!token) {
            vm.fail("Nedostaje token za prijavu.");
            return;
        }

        axios.post(process.env.VUE_APP_API_URL + "sso-login", { token: token })
            .then(response => {
                if (response.data.success) {
                    vm.$store.commit("auth/setUserData", response.data.data.user);
                    localStorage.setItem("access_token", response.data.data.access_token);
                    vm.$router.push(vm.redirectTarget());
                } else {
                    vm.fail("Prijava nije uspjela.");
                }
            })
            .catch(() => {
                vm.fail("Prijava nije uspjela.");
            });
    },

    methods: {
        // Only allow internal relative paths to avoid open redirects.
        redirectTarget() {
            const r = this.$route.query.redirect;
            if (typeof r === "string" && r.charAt(0) === "/" && r.charAt(1) !== "/") {
                return r;
            }
            return "/";
        },

        fail(message) {
            let vm = this;
            vm.error = message;
            setTimeout(() => vm.$router.push("/login"), 2500);
        }
    }
};
</script>

<style scoped>
.sso-loading {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 1.5rem;
}

.sso-card {
    background: #fff;
    border: 1px solid var(--rd-border, #e6e8f0);
    border-radius: var(--rd-radius, 18px);
    box-shadow: var(--rd-shadow-lg, 0 24px 48px -12px rgba(31,28,86,.28));
    padding: 2.75rem 2.5rem;
    text-align: center;
    min-width: 280px;
}

.sso-spinner {
    width: 48px;
    height: 48px;
    margin: 0 auto 1.25rem;
    border-radius: 50%;
    border: 4px solid #e6e8f0;
    border-top-color: var(--rd-primary, #6366f1);
    animation: sso-spin .8s linear infinite;
}
@keyframes sso-spin { to { transform: rotate(360deg); } }

.sso-text { font-weight: 600; color: var(--rd-text, #1e2330); margin: 0; }

.sso-icon {
    width: 56px; height: 56px; margin: 0 auto 1.25rem;
    display: flex; align-items: center; justify-content: center;
    border-radius: 50%; font-size: 1.8rem; font-weight: 800; color: #fff;
}
.sso-icon--err { background: var(--rd-danger, #ef4444); }

.sso-error { color: var(--rd-danger, #ef4444); font-weight: 700; margin: 0 0 .35rem; }
.sso-hint { color: var(--rd-muted, #6b7280); font-size: .9rem; margin: 0; }
</style>
